module.exports = __webpack_public_path__ + "img/login.fe86f808.svg";